import Social from "@/components/common/social/Social";
import Link from "next/link";
import IMG from "@/img/ensemble.webp";
import TRUST_PIOLET_IMG from "@/img/generated-svg-image.svg";
import IATA_IMG from "@/img/iata-logo-header.svg";
import Image from "next/image";
const Copyright = () => {
  return (
    <div className="row justify-between items-center y-gap-10">
      <div className="col-auto">
        <div className="row x-gap-30 y-gap-10">
          <div className="col-auto">
            <div className="d-flex items-center">
              © {new Date().getFullYear()} Roave Technology LLC all right
              reserved.
            </div>
          </div>
          {/* End .col */}

          {/* <div className="col-auto">
            <div className="d-flex x-gap-15">
              <Link href="/privacy-policy" rel="noopener noreferrer">
                Privacy
              </Link>

              <Link href="/terms-and-conditions" rel="noopener noreferrer">
                Terms
              </Link>

              <Link href="/sitemap.xml" rel="noopener noreferrer">
                Site Map
              </Link>
            </div>
          </div> */}
          {/* End .col */}
        </div>
        {/* End .row */}
      </div>
      {/* End .col */}

      <div className="col-auto">
        <div className="row y-gap-10 items-center">
          <div className="col-auto">
            
            <div className="d-flex items-center">
            <Image
              width={67}
                height={70}
                src={IATA_IMG}
                alt={"IATA Logo"}
                loading="lazy"
                className="mb-15 mr-15"
              />

              <Link
                href="//www.securitymetrics.com/site_certificate?id=2384237&tk=57a530321b218e979c8b99ad7bb8f9a6"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  width={150}
                  height={150}
                  src={`https://www.securitymetrics.com/portal/app/ngsm/assets/img/GreyContent_Credit_Card_Safe_White_Rec.png`}
                  alt={"SecurityMetrics card safe certification logo"}
                  loading="lazy"
                />
              </Link>

              <Image
                className="pl-20"
                width={150}
                height={150}
                src={IMG}
                alt={"Ensemble Logo"}
                loading="lazy"
              />
            </div>
          </div>
          <div className="col-auto">
            <div className="d-flex items-center">
              <div className="mx-2" aria-label="Trustpilot">
                <Image
                  width={150}
                  height={150}
                  src={TRUST_PIOLET_IMG}
                  alt={"Trustpilot Logo"}
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* <div className="col-auto">
            <div className="d-flex items-center">
              <button className="d-flex items-center text-14 fw-500 text-dark-1 mr-10">
                <i className="icon-globe text-16 mr-10" />
                <span className="underline">English (US)</span>
              </button>
              <button className="d-flex items-center text-14 fw-500 text-dark-1">
                <i className="icon-usd text-16 mr-10" />
                <span className="underline">USD</span>
              </button>
            </div>
          </div> */}
          {/* End .col */}

          <div className="col-auto">
            <div className="d-flex x-gap-20 items-center">
              <Social />
            </div>
          </div>

          {/* End .col */}
        </div>
      </div>

      <div className="col-auto">
        <div className="d-flex x-gap-20 items-center text-12 pl-10 text-center">
          Roave Travel is a member of the California Sellers of Travel, CST
          2163969-70. Registration as a seller of travel does not constitute
          approval by the State of California
        </div>
      </div>

      {/* End .col */}
    </div>
  );
};

export default Copyright;
